<template>
  <div class="home-header">
    <div class="home-header-content">
      <div class="forbes-quote italic">
        &quot;The results are spellbinding....and there is nothing else like it in the industry.&quot;
      </div>
      <div class="forbes-logo">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  components: {},
  props: {},
  watch: {},
  created () {},
  mounted () {},
  computed: {},
  methods: {}
}
</script>

<style scoped lang="scss">
.home-header{
  background: #6C90B2;
  height: 68px;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  .home-header-content{
    position: relative;
    width: 100%;
    height: 100%;
    padding: 18px 24px;
    max-width: 720px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .forbes-quote{
      text-align: right;
      color: white;
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      padding-left: 36px;
    }
    .forbes-logo{
      position: absolute;
      right: 16px;
      top: 56px;
      height: 44px;
      width: 44px;
      background-color: #000;
      border-radius: 50%;
      background-image: url('~@/assets/forbes-wht.png');
      background-size: 80%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}
// media queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .home-header{
    .home-header-content{
      .forbes-quote{
        text-align: right;
        color: white;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
      }
      .forbes-logo{
        top: 52px;
      }
    }
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .home-header{
    .home-header-content{
      .forbes-quote{
        text-align: right;
        color: white;
        font-size: 16px;
        line-height: 18px;
      }
      .forbes-logo{
        top: 52px;
        height: 52px;
        width: 52px;
      }
    }
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
